import React, { FC, useCallback, useEffect, useState, useContext } from 'react';
import { TasksContext, TasksDispatchContext, TasksProvider, useTask } from '../stateManagement/context';
import {
    AdequacyTypeID,
    IAdequacy,
    IAssessment,
    IAssessmentTemplateGroup,
    IControlMeasure,
    IControlMeasureAdequacy,
    ISummaryKnowledge,
    ISummaryTotalKnowledge
} from "../types/types";

import {Chip, TableCell, TableRow, TextField} from "@material-ui/core";
import AdequacySelection from "./adequacy_selection";



interface ITotalSummaryKnowledgeProps {
    totalSummary: ISummaryTotalKnowledge
    updateSummaryKnowledge: (summaryAssessment: ISummaryTotalKnowledge) => void;
    adequacies: IAdequacy[]
}




const TotalSummaryKnowledge: FC<ITotalSummaryKnowledgeProps> = ({
                                                                    totalSummary ,
                                                                    updateSummaryKnowledge,
                                                                    adequacies
                                                      }) => {

    let tasks = useTask()

    const [write_access, setWriteAccess] = useState<boolean>(false);

                                                        
    useEffect(() => {
        setWriteAccess(tasks.write_access)
    },[tasks])

    const [newSummaryAssessment, setNewSummaryAssessment]=
        useState<ISummaryTotalKnowledge>(totalSummary);

    const renderField = <T,>(obj: T, key: keyof T,
                             label: string,
                             type: string,
                             setObj:(obj:T) => void,
                             updateObj:(obj:T) => void) => {
        return <div>
            <div style={{
                width:"100%",
                margin:"auto",
            }}>
                <TextField
                    fullWidth
                    multiline={true}
                    label={label}
                    disabled={!write_access}
                    value={obj[key]}
                    onChange={(event) => {
                        let v = (event.target.value as string);

                        let c = {...obj} as T;
                        if (type === "string") {
                            (c as any)[key] = v
                        }
                        if (type === "number") {
                            (c as any)[key] = parseFloat(v)
                        }
                        setObj(c)
                    }
                    }
                    onBlur={(event) => {
                        let v = (event.target.value as string);

                        let c = {...obj} as T;
                        if (type === "string") {
                            (c as any)[key] = v
                        }
                        if (type === "number") {
                            (c as any)[key] = parseFloat(v)
                        }
                        setObj(c)
                        updateObj(c)
                    }
                    }
                    type={type}
                />
            </div>
        </div>
    }
    const updateAdequacy = useCallback((selected_id: number ) => {
        let sk = {...totalSummary}
        sk.adequacy_id = selected_id

        updateSummaryKnowledge(sk)
        setNewSummaryAssessment(sk)


    }, [setNewSummaryAssessment, updateSummaryKnowledge]);


    return (<><TableRow>
        <TableCell>Adopted Outcome </TableCell>
        <TableCell>
            <TableCell><AdequacySelection adequacies={adequacies}
                                          type_id={AdequacyTypeID.TotalSummary}
                                          initial_value={(totalSummary.adequacy_id || 0).toString()}
                                          updateCallback={updateAdequacy}/></TableCell>
        </TableCell>
            </TableRow>
        <TableRow>
            <TableCell>Comments </TableCell>
            <TableCell>
                {renderField<ISummaryTotalKnowledge>(
                    newSummaryAssessment,
                    "description",
                    "Comment",
                    "string",
                    setNewSummaryAssessment,
                    updateSummaryKnowledge)}
            </TableCell>
        </TableRow>
    </>)

}

export default TotalSummaryKnowledge


